export interface IUnreadProps {
  total: number
  talk: number
  appointment: number
  message: number
  notice: number
}

export default class UnreadEntity {
  private _props: IUnreadProps

  constructor(props?: IUnreadProps | null) {
    this._props = EmptyUnreadPropsFactory(props)
  }

  get props(): IUnreadProps {
    return this._props
  }

  get clone(): IUnreadProps {
    return structuredClone(this._props)
  }

  get total(): number {
    return this._props.total
  }

  get talk(): number {
    return this._props.talk
  }

  get appointment(): number {
    return this._props.appointment
  }

  get message(): number {
    return this._props.message
  }

  get notice(): number {
    return this._props.notice
  }

  unread(key: string) {
    key = key === 'room' ? 'talk' : key
    return this._props[key as keyof IUnreadProps] || 0
  }
}

export const headers = [{ text: 'ID', value: 'id' }]

export const EmptyUnreadPropsFactory = (props?: Partial<IUnreadProps> | null): IUnreadProps => ({
  total: 0,
  talk: 0,
  appointment: 0,
  message: 0,
  notice: 0,
  ...props
})
